import { type IdToken, useAuth0 } from '@auth0/auth0-vue'
import { computed, type ComputedRef, ref, watch } from 'vue'
import { UserRole } from '@/core/domain/resources/enums/UserRole.ts'

export function useAuthentication() {
  // Composables
  const { idTokenClaims: token } = useAuth0()

  // Refs
  const idTokenClaims = ref<IdToken | undefined>(undefined)

  watch(
    token,
    (nToken) => {
      idTokenClaims.value = nToken
    },
    { immediate: true }
  )

  const fullName = computed(() => idTokenClaims.value?.name ?? null)
  const picture = computed(() => idTokenClaims.value?.picture ?? null)
  const firstnameInitial = computed(
    () => idTokenClaims.value?.given_name?.charAt(0).toUpperCase() ?? null
  )

  const roles: ComputedRef<any[]> = computed(() => {
    return idTokenClaims.value?.[`${__AUTH0_DOMAIN__}/roles`] || []
  })

  const hasRole = (role: UserRole.Values): boolean => roles.value?.includes(role) ?? false

  const isAdmin: ComputedRef<boolean> = computed(() => hasRole(UserRole.Values.ADMIN))
  const isEduEngineer: ComputedRef<boolean> = computed(() => hasRole(UserRole.Values.EDU_ENGINEER))
  const isContentApprover: ComputedRef<boolean> = computed(() => hasRole(UserRole.Values.CONTENT_APPROVER))
  const isPerdir: ComputedRef<boolean> = computed(() => hasRole(UserRole.Values.PERDIR))
  const isCpe: ComputedRef<boolean> = computed(() => hasRole(UserRole.Values.CPE))
  const isTeacher: ComputedRef<boolean> = computed(() => hasRole(UserRole.Values.TEACHER))

  return {
    // infos profil
    fullName,
    picture,
    firstnameInitial,
    // rôles & helpers
    roles,
    isAdmin,
    isEduEngineer,
    isContentApprover,
    isPerdir,
    isCpe,
    isTeacher,
    hasRole
  }
}